import { render } from "./AttendanceAnalyticsChart.vue?vue&type=template&id=b8730352&ts=true"
import script from "./AttendanceAnalyticsChart.vue?vue&type=script&lang=ts"
export * from "./AttendanceAnalyticsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__